import React from "react";

import { SideNavBar, SideNavBarV2 } from "../../components";
const ReportsSideBar = ({ tabs, value = 1, setValue = () => {} }) => {
  const menuTabs = tabs?.map((t) => ({ ...t, icon: "BarChart2" }));
  return <SideNavBarV2 value={value} setValue={setValue} tabs={menuTabs} />;
};

export default ReportsSideBar;
